@if (facade.showWalletCard()) {
  <div
    class="info-card wallet-card"
    [class.wallet-card--negative]="isNegative()"
  >
    <div class="info-card__head">
      <h2 class="info-card__title">
        {{ 'staff.orders.cockpit.wallet.title' | translate }}
      </h2>
    </div>

    @if (summary(); as wallet) {
      <div class="info-row">
        <span class="info-label">{{
          'staff.orders.cockpit.wallet.balance' | translate
        }}</span>
        <span class="info-value wallet-card__balance">{{
          formattedBalance()
        }}</span>
      </div>

      <div class="info-row">
        <span class="info-label">{{
          'staff.orders.cockpit.wallet.status' | translate
        }}</span>
        <span class="wallet-card__status" [class]="statusBadgeClass()">{{
          statusKey() | translate
        }}</span>
      </div>

      @if (formattedDailyRate()) {
        <div class="info-row">
          <span class="info-label">{{
            'staff.orders.cockpit.wallet.dailyCharge' | translate
          }}</span>
          <span class="info-value">{{ formattedDailyRate() }}</span>
        </div>
      }

      @if (wallet.block_reason) {
        <p class="wallet-card__hint">
          {{ blockReasonLabelKey(wallet.block_reason) | translate }}
        </p>
      } @else if (isNegative()) {
        <p class="wallet-card__hint">
          {{ 'staff.orders.cockpit.wallet.negativeHint' | translate }}
        </p>
      }

      @if (statement().length > 0) {
        <div class="wallet-card__statement">
          <p class="info-label wallet-card__statement-title">
            {{ 'staff.orders.cockpit.wallet.statement.title' | translate }}
          </p>
          <ul class="wallet-card__statement-list">
            @for (item of statement(); track item.id) {
              <li class="wallet-card__statement-item">
                <div class="wallet-card__statement-main">
                  <span>{{ statementTypeLabel(item) | translate }}</span>
                  <span class="wallet-card__statement-date">{{
                    item.created_at | date: 'd MMM yyyy, HH:mm' : '+0300' : 'ru'
                  }}</span>
                  @if (statementContext(item); as context) {
                    <span class="wallet-card__statement-context">{{
                      context.key | translate: context.params
                    }}</span>
                  }
                  @if (statementReceiptUrl(item); as receiptUrl) {
                    <span class="wallet-card__statement-context">
                      {{
                        'staff.orders.cockpit.wallet.statement.context.receiptLabel'
                          | translate
                      }}
                      <a
                        class="wallet-card__statement-link"
                        [href]="receiptUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{
                          'staff.orders.cockpit.wallet.statement.context.receiptLink'
                            | translate
                        }}
                      </a>
                    </span>
                  }
                  @if (statementTransactionId(item); as transactionId) {
                    <span class="wallet-card__statement-context">
                      {{
                        'staff.orders.cockpit.wallet.statement.context.transactionId'
                          | translate: { id: transactionId }
                      }}
                    </span>
                  }
                  @if (statementStaffComment(item); as comment) {
                    <span class="wallet-card__statement-context">
                      {{
                        'staff.orders.cockpit.wallet.statement.context.staffComment'
                          | translate: { comment }
                      }}
                    </span>
                  }
                </div>
                <span
                  class="wallet-card__statement-amount"
                  [class.wallet-card__statement-amount--positive]="
                    item.amount_bynd > 0
                  "
                  [class.wallet-card__statement-amount--negative]="
                    item.amount_bynd < 0
                  "
                >
                  {{ formatStatementAmount(item.amount_bynd) }}
                </span>
              </li>
            }
          </ul>
          @if (canLoadMore()) {
            <button
              type="button"
              class="wallet-card__load-more"
              [disabled]="statementLoading()"
              (click)="loadMoreStatement()"
            >
              {{
                (statementLoading()
                  ? 'staff.orders.cockpit.wallet.statement.loading'
                  : 'staff.orders.cockpit.wallet.statement.loadMore'
                ) | translate
              }}
            </button>
          }
        </div>
      }
    } @else {
      <p class="wallet-card__hint">
        {{ 'staff.orders.cockpit.wallet.unavailable' | translate }}
      </p>
    }
  </div>
}
